const DEFAULT_PREFIX = 'cc.';

export const localPut = <T extends unknown>(
  key: string,
  value: T,
  prefix: string = DEFAULT_PREFIX
) => {
  localStorage.setItem(`${prefix}${key}`, JSON.stringify(value));
};

export const localDelete = (key: string, prefix: string = DEFAULT_PREFIX) => {
  localStorage.removeItem(`${prefix}${key}`);
};

export const localGet = <T extends unknown>(key: string, prefix: string = DEFAULT_PREFIX) => {
  return JSON.parse(localStorage.getItem(`${prefix}${key}`)) as T;
};
